export default __webpack_public_path__ + "static/media/Clearance_Specials_Web_Banner_Category_Cover_V1.33e04f08.jpg";